// Phase 6 — Track B T-B5. Dates copy.
// Phase 7 D6 — Track E. Adds copy for the add/edit DateDialog, the
// ReminderOffsetEditor, the DeleteDateDialog, the DatesToolbar, and the
// destructive-delete toast (Q-10 sparse policy: destructive only).

export const datesCopy = {
  navLabel: 'Dates',
  pageTitle: 'Important dates',
  pageSubtitle: 'Birthdays, anniversaries, and other dates that matter.',
  emptyTitle: 'No upcoming dates',
  emptyBody: 'Add a date in Phase 7.',
  loadingLabel: 'Loading dates',
  errorTitle: 'Could not load dates',
  errorBody: 'Try again in a moment.',
  retry: 'Retry',
  columns: {
    occursOn: 'Date',
    label: 'Event',
    nextOccurrence: 'Next',
  },
  recurrenceLabels: {
    none: 'One-off',
    yearly: 'Yearly',
    monthly: 'Monthly',
  },

  // ---- Toolbar (Phase 7 D6) -----------------------------------------------
  toolbar: {
    addLabel: 'Add date',
    addAriaLabel: 'Add an important date',
    toolbarAriaLabel: 'Dates actions',
  },

  // ---- Add / edit dialog (Phase 7 D6) -------------------------------------
  dialog: {
    addTitle: 'Add date',
    addDescription: 'Track a birthday, anniversary, or other date that matters.',
    editTitle: 'Edit date',
    editDescription: 'Update the details for this date.',
    titleLabel: 'Title',
    titlePlaceholder: "What's the occasion?",
    occursOnLabel: 'Date',
    recurrenceLabel: 'Recurrence',
    recurrenceIntervalLabel: 'Every N months',
    recurrenceIntervalHelp: 'Every N months — e.g. 3 = quarterly.',
    notesLabel: 'Notes',
    notesPlaceholder: 'Optional note',
    remindersLabel: 'Reminders',
    submitAdd: 'Add date',
    submitEdit: 'Save changes',
    cancel: 'Cancel',
    deleteFromEdit: 'Delete',
    invalidTitle: 'Enter a title.',
    invalidDate: 'Enter a valid date (YYYY-MM-DD).',
    invalidInterval: 'Enter a number between 1 and 12.',
    submitFailed: 'Could not save the date. Try again.',
  },

  // ---- Reminder offset editor (Phase 7 D6) --------------------------------
  reminders: {
    emptyState:
      'No reminders set. Add one below to get notified before this date.',
    addLabel: 'Add reminder',
    constraintHelp: '0 = on the day, 7 = a week before, etc.',
    offsetLabel: 'Days before',
    removeAriaLabel: 'Remove reminder offset',
    invalidOffset: 'Enter a number between 0 and 365.',
  },

  // ---- Delete confirmation dialog (Phase 7 D6) ----------------------------
  deleteDialog: {
    title: 'Delete date',
    intro: 'This permanently removes the date and its reminders. There is no undo.',
    summaryLabel: 'Summary',
    confirm: 'Delete',
    cancel: 'Cancel',
    failed: 'Could not delete the date. Try again.',
  },
  deletedToast: 'Date deleted',
} as const;
